import script from "./DescriptionFullCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./DescriptionFullCourse.vue?vue&type=script&setup=true&lang=js"

import "./DescriptionFullCourse.vue?vue&type=style&index=0&id=48c224f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c224f3"]])

export default __exports__